import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSettings } from '../context/SettingsContext';
import {
  FiHome, FiTrendingUp, FiFileText, FiSend,
  FiTarget, FiUsers, FiLogOut,
} from 'react-icons/fi';
import './Sidebar.css';
import { LocalImages } from '../utils/LocalImages';

export default function Sidebar() {
  const { user, logout } = useAuth();
  const { settings } = useSettings();
  const navigate = useNavigate();
  const role = user?.role;
  // Treat legacy 'admin' role same as 'ceo' (normalised at next login by backend)
  const isCEO   = role === 'ceo' || role === 'admin';
  const isHR    = role === 'hr';
  const isSales = role === 'sales';

  const navItems = [];

  if (isCEO || isHR) {
    navItems.push({ to: '/dashboard', label: 'Dashboard', Icon: FiHome });
  }
  if (isCEO || isSales || (isHR && settings.hr_can_see_crm !== false)) {
    navItems.push({ to: '/crm', label: 'CRM', Icon: FiTrendingUp });
  }
  if (isCEO || isSales || (isHR && settings.hr_can_see_crm !== false)) {
    navItems.push({ to: '/contracts', label: 'Contracts', Icon: FiFileText });
  }
  if (isCEO || isSales || (isHR && settings.hr_can_see_crm !== false)) {
    navItems.push({ to: '/proposals', label: 'Proposals', Icon: FiSend });
  }
  navItems.push({ to: '/targets', label: isSales ? 'My Targets' : 'Targets', Icon: FiTarget });
  if (isCEO || isHR) {
    navItems.push({ to: '/users', label: 'Users', Icon: FiUsers });
  }

  const handleLogout = () => { logout(); navigate('/login'); };
  const initials = (user?.full_name || user?.username || 'U')[0].toUpperCase();

  return (
    <aside className="sidebar">
      {/* Brand */}
      <div className="sidebar-brand">
        <img src={LocalImages.veramasaLogo} className="sidebar-logo" alt="Veramasa" />
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        <p className="sidebar-nav-label">MENU</p>
        {navItems.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `sidebar-link${isActive ? ' sidebar-link--active' : ''}`
            }
          >
            <Icon size={17} className="sidebar-link-icon" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      {/* User + Logout */}
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">{initials}</div>
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{user?.full_name || user?.username}</span>
            <span className="sidebar-user-role sidebar-role-ceo">
              {isCEO ? 'CEO' : isHR ? 'HR' : 'Sales'}
            </span>
          </div>
        </div>
        <button className="sidebar-logout" onClick={handleLogout} title="Logout">
          <FiLogOut size={15} />
        </button>
      </div>
    </aside>
  );
}
